import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";
import moment from "moment";

const budgetCategoriesAdapter = createEntityAdapter({
  sortComparer: (a, b) => b.valueDate.localeCompare(a.valueDate)
});

const initialState = {
  budgetCategories: budgetCategoriesAdapter.getInitialState(),

  list: {
    currentYear: +moment().format("YYYY"),
    currentMonth: +moment().format("MM") - 1,
    showTransactions: false,
  },

  editor: {
    show: false,
    mode: null,
    deleteConfirmationModal: false
  }
};

export const budgetCategoriesSlice = createSlice({
  name: "budgetCategories",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.category = action.payload.category;
      state.editor.valueDate = action.payload.valueDate;
      state.editor.deleteConfirmationModal = false;
    },

    hideEditor: state => {
      state.editor.show = false;
      state.editor.deleteConfirmationModal = false;
    },

    showHideDeleteConfirmationModal: (state, action) => {
      state.editor.deleteConfirmationModal = action.payload;
    },

    toNextYear: state => {
      state.list.currentYear++;
    },

    toPrevYear: state => {
      state.list.currentYear--;
    },

    toPeriod: (state, action) => {
      state.list.currentYear = action.payload.year;
      state.list.currentMonth = action.payload.month;
    },

    updateCategories: (state, action) => {
      budgetCategoriesAdapter.setMany(state.budgetCategories, action.payload.u || []);
      budgetCategoriesAdapter.removeMany(state.budgetCategories, action.payload.d || []);
    },

    toggleTransactionsVisibility: (state) => {
      state.list.showTransactions = !state.list.showTransactions;
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      budgetCategoriesAdapter.setMany(state.budgetCategories, action.payload.budgetCategories);
    });
  }
});

export const {
  showEditor: rxShowBudgetCategoryEditor,
  hideEditor: rxHideBudgetCategoryEditor,
  updateCategories: rxUpdateBudgetCategories,
  toggleTransactionsVisibility: rxToggleTransactionsVisibility,
  showHideDeleteConfirmationModal: rxShowHideDeleteConfirmationModal,

  toNextYear: rxToNextYear,
  toPrevYear: rxToPrevYear,
  toPeriod: rxToPeriod
} = budgetCategoriesSlice.actions;

export const {
  selectAll: selectAllBudgetCategories
} = budgetCategoriesAdapter.getSelectors(state => state.budgetCategories.budgetCategories);

export const listConfigSelector = state => state.budgetCategories.list;
export const editorConfigSelector = state => state.budgetCategories.editor;

export default budgetCategoriesSlice.reducer;
